import { Transition } from "framer-motion";

/**
 * Centralized transition presets for consistent animation timing across the app.
 * Use these instead of hardcoding transition values in components.
 */

// Easing functions
export const easings = {
  // Smooth deceleration - great for elements entering the screen
  easeOut: [0.16, 1, 0.3, 1] as const,
  // Smooth acceleration then deceleration - great for UI interactions
  easeInOut: [0.4, 0, 0.2, 1] as const,
  // Spring-like bounce - great for playful animations
  bounce: [0.68, -0.55, 0.265, 1.55] as const,
};

// Duration presets (in seconds)
export const durations = {
  fast: 0.2,
  normal: 0.4,
  slow: 0.6,
  verySlow: 1.0,
  progress: 1.2, // For progress bars/rings
};

// Delay presets (in seconds)
export const delays = {
  none: 0,
  short: 0.1,
  medium: 0.2,
  long: 0.4,
  stagger: 0.05, // For staggered list animations
};

// Pre-built transition configs
export const transitions = {
  // Default smooth transition
  default: {
    duration: durations.normal,
    ease: easings.easeOut,
  } as Transition,

  // Fast transition for micro-interactions
  fast: {
    duration: durations.fast,
    ease: easings.easeOut,
  } as Transition,

  // Slow transition for emphasis
  slow: {
    duration: durations.slow,
    ease: easings.easeOut,
  } as Transition,

  // Progress bar/ring animation
  progress: {
    duration: durations.progress,
    ease: easings.easeOut,
    delay: delays.medium,
  } as Transition,

  // Spring animation for bouncy feel
  spring: {
    type: "spring",
    stiffness: 300,
    damping: 30,
  } as Transition,

  // Gentle spring for subtle bounce
  gentleSpring: {
    type: "spring",
    stiffness: 200,
    damping: 25,
  } as Transition,

  // Number counting animation
  counting: {
    duration: durations.slow,
    ease: "linear",
  } as Transition,
};
